import React from 'react';
import { Report as ReportShape } from '../../shapes/report';
import ReportHeaderTitle from './report-header-title';
import ReportHeaderLocation from './report-header-location';
import ReportHeaderRoute from './report-header-route';

class ReportHeader extends React.Component {

  render() {
    return (
      <React.Fragment>
        <ReportHeaderTitle report={this.props.report} />
        <br />
        <br />
        <ReportHeaderLocation report={this.props.report} />
        {
          this.props.report.route ? (
            <React.Fragment>
              <br />
              <ReportHeaderRoute report={this.props.report} />
            </React.Fragment>
          ) : null
        }
      </React.Fragment>
    )
  }

}

ReportHeader.propTypes = {
  report: ReportShape.isRequired
};

export default ReportHeader;


// WEBPACK FOOTER //
// ./src/views/report/report-header.js